<template>
  <section id="HomeNewsListSection" ref="MainContent">
    <div class="main_container">
      <header class="section_header">
        <div class="text_box">
          <p class="title" data-section-title>最新消息</p>
          <h3 class="sub_title" data-section-sub-title>
            優惠活動 / 重要公告 / 資訊分享
          </h3>
          <p
            class="content textarea_content"
            data-section-content
            v-html="$store.getters.columnData('home_news_list_content')"
          ></p>
        </div>
      </header>

      <ol class="news_list">
        <li
          class="news_item"
          v-for="(item, itemIndex) in newsData"
          :key="`news_${itemIndex}`"
          data-card-item
        >
          <router-link class="card" :to="`/news/${item.NewsID}`">
            <div class="image_box">
              <LazyLoadingImage
                :src="$store.getters.imageUrl(item.Image1)"
                :alt="item.Title"
              />
            </div>
            <div class="text_box">
              <h4 class="title">{{ item.Title }}</h4>
              <div class="category_box">
                <p class="date">{{ item.created_at.slice(0, 10) }} ・</p>
                <p class="category">{{ item.CategoryTitle }}</p>
              </div>
              <p class="content">{{ GetContent(item) }}</p>
            </div>
          </router-link>
        </li>
      </ol>

      <div class="action_box" data-section-content>
        <router-link to="/news" class="main_button"
          >查看全部文章
          <span class="icon material-symbols-rounded"> east </span>
          <span class="bg_box"></span>
          <span class="shadow_box"></span
        ></router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { ServiceSection } from "@/animations/home/serviceSection.js";
import LazyLoadingImage from "@/components/LazyLoadingImage.vue";
export default {
  name: "HomeNewsListSection",
  components: {
    LazyLoadingImage,
  },
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new ServiceSection(this.$refs.MainContent);
      this.animation.Reset();
    },
    SetAnimation() {
      // this.animation.Reset();
      // this.animation.Setup();
    },
    GetContent(item) {
      return (
        item.Content.replace(/<[^>]+>/g, "")
          .replace("&nbsp;", "")
          .substring(0, 100) + "..."
      );
    },
  },
  computed: {
    newsData() {
      if (this.$store.state.newsData == null) {
        return [];
      }
      return this.$store.state.newsData.slice(0, 3);
    },
  },
  mounted() {
    // this.InitAnimation();
  },
};
</script>
